<div class='delivery-events-page'>

	<toolbar icon='Delivery'>
		<button class="btn btn-light" (click)='deliveryService.reloadData()' KendoTooltip [attr.title]="'Reload'"><i class='far fa-sync-alt' style="display: inline-block;width: 1.5em;"></i></button>

		<droplist [items]='[]' [popupConfig]='popupConfig' [navigation]='true'>
		</droplist>

		<div style='display:inline-block;width:300px'>
			<trimester-droplist [trimesterWindow]='trimesterWindow'></trimester-droplist>
		</div>
		<!-- 
		<button class="btn btn-light">
			<icon-text [iconContext]='{ text: "Monkey", iconClass: "fa-monkey", iconStyle:"fa-regular", hideText: "lt-md" }'></icon-text>
		</button>

		<button class="btn btn-light">
			<icon-text [iconContext]='{ text: "Pizza", iconClass: "fa-pizza-slice", iconStyle:"fa-regular", hideText: "lt-lg" }'></icon-text>
		</button> -->

	</toolbar>

	<page-tabs [tabNames]='["Events", "Tab1", "Tab2"]' [pageService]='pageService' (layoutChange)='onLayoutChange($event)'>
		<ng-template pageTab1>
			<delivery-events-views-part></delivery-events-views-part>
		</ng-template>

		<ng-template pageTab2>
			<delivery-events-tab-1-part></delivery-events-tab-1-part>
		</ng-template>

		<ng-template pageTab3>
			<delivery-events-tab-2-part></delivery-events-tab-2-part>
		</ng-template>
	</page-tabs>

</div>